export default "__VITE_PUBLIC_ASSET__04089fba__"